import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {AutoDistributionBoltIcon} from 'shells/icon/svg/auto-distribution-bolt-icon';
import {ContactIcon} from 'shells/icon/svg/contact-icon';
// @ts-expect-error - imported from .js/.jsx file
import {TagIcon} from 'shells/icon/svg/tag-icon';
// @ts-expect-error - imported from .js/.jsx file
import {TeamIcon} from 'shells/icon/svg/team-icon';
import {Body} from 'shells/typography/body';

import type {OutcomeType} from 'nutshell-graphql-types';
import type {
    SalesAutomationClosedLeadAutomation_followupLeadAutomations as FollowupLeadAutomation,
    SalesAutomationClosedLeadAutomation_followupLeadAutomations_assigneeOrRule as FollowupLeadAutomationAssigneeOrRule,
} from 'nutshell-graphql-types';

import {AUTO_ASSIGN_OPTION, SAME_ASSIGNEE_OPTION} from '../../../../core/form/fields/consts';

import {SalesAutomationCard} from '../../cards/sales-automation-card';

type Props = {
    automation: FollowupLeadAutomation;
    outcomeType: OutcomeType;
};

export function ClosedLeadFollowupRuleCard(props: Props) {
    const {name, icon: Icon, color} = getAssigneeRowData(props.automation.assigneeOrRule);

    return (
        <SalesAutomationCard
            key={props.automation.id}
            type='closedLeadFollowupRule'
            parentId={props.outcomeType}
            entityId={props.automation.id}
        >
            <div className='flex flex-dir-col align-start gap-8 full-width'>
                <Body color='dark' truncate={{type: 'inline'}}>
                    {props.automation.newStageset.name}
                </Body>
                {renderRow(Icon, color, name)}
                {props.automation.tags &&
                    props.automation.tags.length > 0 &&
                    renderRow(
                        TagIcon,
                        colors.greyLt,
                        props.automation.tags.map((tag) => tag && tag.name).join(', ')
                    )}
            </div>
        </SalesAutomationCard>
    );
}

const renderRow = (Icon: React.ComponentType<any>, iconColor: string, text: string) => {
    return (
        <div className='flex flex-dir-row gap-8 align-center full-width'>
            <Icon size='15' fill={iconColor} wrapWithDiv={false} />
            <div className='truncate' title={text}>
                <Body size='small'>{text}</Body>
            </div>
        </div>
    );
};

function getAssigneeRowData(assigneeOrRule: FollowupLeadAutomationAssigneeOrRule): {
    icon: React.ComponentType<any>;
    color: string;
    name: string;
} {
    if (assigneeOrRule.__typename === 'LeadAssigneeRule') {
        if (assigneeOrRule.assignmentRule === 'AUTO_ASSIGN') {
            return {
                name: AUTO_ASSIGN_OPTION.name,
                icon: AutoDistributionBoltIcon,
                color: colors.blue,
            };
        }

        return {
            name: SAME_ASSIGNEE_OPTION.name,
            icon: AutoDistributionBoltIcon,
            color: colors.blue,
        };
    }

    return assigneeOrRule.__typename === 'User'
        ? {
              name: assigneeOrRule.name,
              icon: ContactIcon,
              color: colors.orange,
          }
        : {
              name: assigneeOrRule.name,
              icon: TeamIcon,
              color: colors.orangeDk,
          };
}
